import './App.css';
import { Routes, Route } from 'react-router-dom';
import { AdminLayout } from './components/AdminLayout';
import { Dashboard } from './pages/Dashboard';
import { AdminLogin } from './Login/AdminLogin';
import PrivateRoute from './components/PrivateRoute';
import { RegisteredUsers } from './pages/Users/RegisteredUsers';
import AdminPlanManagement from './pages/plans/AdminPlanManagement';
import AllComplaints from './components/complaints/AllComplaints';
import AdminAnalytics from './pages/AdminAnalytics';
import SessionTimedOut from './components/SessionTimedOut';
import { UserDeviceDetails } from './pages/Users/UserDeviceDetails';
import { ActivePlanUsers } from './pages/plans/ActivePlanUsers';
import { InactivePlanUsers } from './pages/plans/InactivePlanUsers';
import AdminNotifications from './pages/AdminNotifications';
import { SubAdminLogin } from './Login/SubAdminLogin';
import AllStaff from './components/staff/AllStaff';
import StaffForm from './components/staff/StaffForm';
import SingleStaff from './components/staff/SingleStaff';
import ScrollToTop from "./components/ScrollToTop";
import AllPlans from './pages/plans/AdminPlanManagement';
import AddEditPlan from './pages/plans/AddEditPlan';
import SinglePlan from './pages/plans/SinglePlan';
import Settings from './pages/Settings/Settings';
import { Profile } from './pages/Settings/Profile';
import AddEditRole from './components/staff/AddEditRole';
import AllRoles from './components/staff/AllRoles';
import SingleRoleDetails from './components/staff/SingleRoleDetails';
import AllDepartments from './components/staff/AllDepartments';
import StaffProfile from './components/staff/StaffProfile';
import AllComplaintTypes from './components/complaints/AllComplaintTypes';
import PendingComplaints from './components/complaints/PendingComplaints';
import InProgressComplaints from './components/complaints/InProgressComplaints';
import ResolvedComplaints from './components/complaints/ResolvedComplaints';
import AllMasters from './pages/Masters/AllMasters';
import ActiveMasters from './pages/Masters/ActiveMasters';
import InactiveMasters from './pages/Masters/InactiveMasters';
import MasterEdit from './pages/Masters/MasterEdit';
import AllUsers from './pages/Users/AllUsers';
import ActiveUsers from './pages/Users/ActiveUsers';
import InactiveUsers from './pages/Users/InactiveUsers';
import UserEdit from './pages/Users/UserEdit';
import SingleMaster from './pages/Masters/SingleMaster';
import SingleUser from './pages/Users/SingleUser';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminLoginLogs from './Login/AdminLoginLogs';
import StaffLoginLogs from './Login/StaffLoginLogs';

function App() {
  return (
    <>
      <ScrollToTop />
      <SessionTimedOut />
      <Routes>
        <Route path="/" element={<AdminLogin />} />
        <Route path="/staff-login" element={<SubAdminLogin />} />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          } InactivePlanUsers
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="staff-profile" element={<StaffProfile />} />

          <Route path='masters/all' element={<AllMasters statusFilter='all' />} />
          <Route path='masters/active' element={<ActiveMasters statusFilter='active' />} />
          <Route path='masters/inactive' element={<InactiveMasters statusFilter='inactive' />} />
          <Route path='master/edit/:id' element={<MasterEdit />} />
          <Route path="/admin/master/view/:id" element={<SingleMaster />} />

          <Route path='users/all' element={<AllUsers statusFilter='all' />} />
          <Route path='users/active' element={<ActiveUsers statusFilter='active' />} />
          <Route path='users/inactive' element={<InactiveUsers statusFilter='inactive' />} />
          <Route path='user/edit/:id' element={<UserEdit />} />
          <Route path="/admin/user/view/:id" element={<SingleUser />} />

          {/* <Route path="users" element={<RegisteredUsers />} />
          <Route path='user/:id' element={<UserDeviceDetails />} /> */}

          <Route path="plans" element={<AllPlans />} />
          <Route path="plans/new" element={<AddEditPlan />} />
          <Route path="plans/:id" element={<SinglePlan />} />
          <Route path="plans/:id/edit" element={<AddEditPlan />} />

          <Route path="plans/:planId/active-users" element={<ActivePlanUsers />} />
          <Route path="plans/:planId/inactive-users" element={<InactivePlanUsers />} />
          <Route path="analytics" element={<AdminAnalytics />} />

          <Route path="complaints/all" element={<AllComplaints />} />
          <Route path="complaints/complaint-types" element={<AllComplaintTypes />} />
          <Route path="complaints/pending" element={<PendingComplaints />} />
          <Route path="complaints/in-progress" element={<InProgressComplaints />} />
          <Route path="complaints/resolved" element={<ResolvedComplaints />} />

          <Route path='notifications' element={<AdminNotifications />} />
          <Route path="staff" element={<AllStaff />} />
          <Route path="staff/add" element={<StaffForm />} />
          <Route path="staff/add/:id" element={<StaffForm />} />
          <Route path="staff/:id" element={<SingleStaff />} />

          <Route path="roles" element={<AllRoles />} />
          <Route path="add-roles" element={<AddEditRole />} />
          <Route path="roles/edit/:id" element={<AddEditRole />} />
          <Route path="roles/details/:id" element={<SingleRoleDetails />} />

          <Route path="departments" element={<AllDepartments />} />

          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />

          <Route path="admin-logs" element={<AdminLoginLogs />} />
          <Route path="staff-logs" element={<StaffLoginLogs/>}/>
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </>
  );
}

export default App;